import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
	selector: '[pgsRequiredField]'
})
export class RequiredFieldDirective implements AfterViewInit {

	// For dynamic directives see: https://stackoverflow.com/questions/41298168/how-to-dynamically-add-a-directive
	// @HostBinding('attr.ngbTooltip') tooltip = new NgbTooltip(this.el, this.renderer, this.injector, this.componentFactoryResolver,
	// 	this.viewContainerRef, { placement: 'top', container: '', triggers: '' }, this.ngZone)


	// constructor(private el: ElementRef, private renderer: Renderer2, private injector: Injector,
	// 	private componentFactoryResolver: ComponentFactoryResolver, private viewContainerRef: ViewContainerRef,
	// 	private ngZone: NgZone) {

	// }

	constructor(private el: ElementRef, private renderer: Renderer2) {

	}

	// ngOnInit(): void {
		// this.tooltip.ngbTooltip = 'Este campo es requerido';
		// this.tooltip.ngOnInit();
	// }

	ngAfterViewInit(): void {
		const spanElement = this.renderer.createElement('span');
		this.renderer.addClass(spanElement, 'text-danger');
		spanElement.textContent = ' *';
		this.renderer.appendChild(this.el.nativeElement, spanElement);
		this.renderer.setAttribute(this.el.nativeElement, 'title', 'Este campo es requerido');
	}

	// ngOnDestroy(): void {
	// 	this.tooltip.ngOnDestroy();
	// }

}
